<template>
    <section
        ref="section22"
        :class="[
            Object.keys(validationErrors).length > 0 ? 'has-errors' : '',
            'mx-auto flex h-full flex-col',
        ]"
    >
        <v-add-listing-head :routes="routes" :step="22"></v-add-listing-head>
        <main
            class="flex h-full flex-col items-center justify-between overflow-y-scroll px-4 py-8 md:px-12"
        >
            <figure class="relative flex max-w-3xl flex-col gap-11 lg:w-full">
                <figure class="ml-auto mr-auto flex w-full max-w-lg gap-3">
                    <div><v-icon icon="inventory" size="8"></v-icon></div>
                    <div class="flex flex-col justify-center">
                        <div class="mb-3 mr-6 text-heading-3-desktop">
                            Katero dokumentacijo ima nepremičnina?
                        </div>
                        <div class="text-body-regular text-black-40">
                            Izberete lahko več možnosti.
                        </div>
                    </div>
                    <v-lightbox is-authenticated footerless>
                        <template v-slot:trigger>
                            <div
                                class="absolute right-0 top-0 flex h-8 w-8 cursor-pointer items-center justify-center rounded-full bg-white shadow hover:bg-green-25"
                            >
                                <v-icon icon="question-mark" size="4"></v-icon>
                            </div>
                        </template>
                        <template v-slot:head>
                            <div class="flex items-start">
                                <v-icon
                                    icon="question-mark"
                                    class="mr-2.5"
                                    size="4.5"
                                ></v-icon>
                                <div>
                                    Dodatne informacije
                                </div>
                            </div>
                        </template>
                        <template v-slot:content>
                            <p class="mb-[10px] text-icon-text-medium">
                                Gradbeno dovoljenje
                            </p>
                            <p class="mb-4 text-body-regular">
                                Gradbeno dovoljenje je uradni dokument, ki ga izda pristojna občinska uprava ali gradbeni organ in ki dovoljuje izvajanje določenih gradbenih dejavnosti na določenem območju. To dovoljenje je potrebno pred začetkom gradnje novega objekta, rekonstrukcije ali spremembe obstoječega objekta.
                            </p>
                            <p class="mb-4 text-body-regular">
                                Pridobivanje gradbenega dovoljenja je ključnega pomena, saj zagotavlja, da so gradbena dela skladna z lokalnimi gradbenimi predpisi, prostorskimi načrti in drugimi predpisi. V postopku pridobivanja gradbenega dovoljenja se preveri, ali načrti ustrezajo zemljiščnim predpisom, varnostnim zahtevam, okoljskim standardom in drugim veljavnim predpisom.
                            </p>
                            <p class="mb-8 text-body-regular">
                                Brez ustreznega gradbenega dovoljenja se gradbena dela ne smejo začeti, in neupoštevanje tega zahteva lahko privede do sankcij, vključno s prenehanjem gradbenih del, globami ali drugimi pravnimi posledicami. V praksi gradbeno dovoljenje ščiti tako lastnike nepremičnine kot tudi širšo skupnost, saj zagotavlja, da se gradbena dela izvajajo v skladu z določenimi standardi in pravili.
                            </p>

                            <p class="mb-[10px] text-icon-text-medium">
                                Uporabniško dovoljenje
                            </p>
                            <p class="mb-4 text-body-regular">
                                Uporabno dovoljenje je uradni dokument, ki ga izda pristojna občinska uprava ali gradbeni organ po končani gradnji ali rekonstrukciji objekta. To dovoljenje potrjuje, da je zgrajeni objekt zgrajen v skladu s pogoji gradbenega dovoljenja in da izpolnjuje vse potrebne tehnične, varnostne, higienske in druge predpise za varno bivanje ali uporabo.
                            </p>
                            <p class="mb-4 text-body-regular">
                                Uporabno dovoljenje se pridobi po zaključku gradbenih del, preden se objekt začne uporabljati. To dovoljenje pomeni, da so bila vsa gradbena dela izvedena v skladu z načrti in predpisi ter da objekt izpolnjuje vse potrebne zahteve za varno in zakonito uporabo.
                            </p>
                            <p class="mb-8 text-body-regular">
                                Brez veljavnega uporabnega dovoljenja lahko lastniki ali uporabniki objekta naletijo na težave, kot so denarne kazni ali celo prepoved uporabe objekta. Uporabno dovoljenje je torej pomemben dokument, ki potrjuje zakonitost in skladnost zgradbe ter zagotavlja, da je varna in primerna za uporabo v skladu z namenom, za katerega je bila zgrajena.
                            </p>

                            <p class="mb-[10px] text-icon-text-medium">
                                Zemljiškoknjižni izpisek
                            </p>
                            <p class="mb-4 text-body-regular">
                                Zemljiškoknjižni izpisek je uradni dokument, ki vsebuje informacije o lastništvu in drugih pravnih dejstvih v zvezi z nepremičnino. To je izpis iz zemljiške knjige, ki je uradna javna evidenca o lastništvu nepremičnin.
                            </p>
                            <p class="text-body-regular">
                                Med možnostmi izberite, ali je vaša nepremičnina:
                            </p>
                            <ul class="mb-4 text-body-regular list-disc pl-6">
                                <li>
                                    Podatki o nepremičnini: Vključujejo natančen opis nepremičnine, njeno lokacijo, parcelno številko in podobne tehnične informacije.
                                </li>
                                <li>
                                    Lastniški podatki: Navaja trenutnega lastnika nepremičnine in morebitne druge imetnike pravic na njej. Prav tako lahko prikaže pretekle lastniške spremembe.
                                </li>
                                <li>
                                    Pravice in bremena: Opozarja na morebitne hipoteke, služnosti, stavbne pravice in druge omejitve ali obremenitve na nepremičnini.
                                </li>
                                <li>
                                    Podatki o vpisu: Vključujejo datum vpisa podatkov in morebitne spremembe, ki so se zgodile v zvezi z nepremičnino.
                                </li>
                            </ul>
                            <p class="mb-8 text-body-regular">
                                Zemljiški izpisek je pomemben dokument, ko se obravnavajo pravna vprašanja ali transakcije v zvezi z nepremičnino, saj zagotavlja transparentnost in zanesljive informacije o njenem statusu. Pred nakupom nepremičnine je priporočljivo pridobiti zemljiško knjižni izpisek, da se preveri njeno pravno stanje in lastniško strukturo.
                            </p>

                            <p class="mb-[10px] text-icon-text-medium">
                                Tloris
                            </p>
                            <p class="mb-4 text-body-regular">
                                Tloris nepremičnine predstavlja načrt ali risbo, ki prikazuje horizontalni pogled na razporeditev prostorov znotraj določene nepremičnine. Tloris je običajno izrisan na ravnem, dvodimenzionalnem platnu in prikazuje razporeditev sob, hodnikov, kuhinje, kopalnice, spalnic in drugih prostorov v stavbi ali stanovanju. Ta načrt omogoča pregled nad razporeditvijo prostorov in merami ter služi kot osnova za načrtovanje in razumevanje prostorske strukture.
                            </p>
                            <p class="text-body-regular">
                                Elementi, ki so običajno vključeni v tloris, so:
                            </p>
                            <ul class="mb-4 text-body-regular list-disc pl-6">
                                <li>
                                    Stene: Prikazujejo lokacijo sten in njihovo razporeditev v prostoru.
                                </li>
                                <li>
                                    Okna in vrata: Označujejo odprtine za okna in vrata ter njihovo lokacijo.
                                </li>
                                <li>
                                    Prostori: Različni prostori so lahko označeni, na primer kuhinja, spalnica, dnevna soba, kopalnica, hodnik itd.
                                </li>
                                <li>
                                    Mere: Podaja dimenzije prostorov in razdalje med stenami.
                                </li>
                            </ul>
                            <p class="mb-8 text-body-regular">
                                Tloris je ključen dokument pri načrtovanju in oblikovanju prostora, saj arhitektom, oblikovalcem notranjosti, nepremičninskim agentom in drugim omogoča jasno predstavo o razporeditvi prostorov. Pri prodaji ali oddaji nepremičnine je tloris tudi koristen pripomoček za potencialne kupce ali najemnike, saj jim omogoča, da si lažje predstavljajo prostorsko zasnovo nepremičnine.
                            </p>

                            <p class="mb-[10px] text-icon-text-medium">
                                Katasterski načrt
                            </p>
                            <p class="mb-4 text-body-regular">
                                Katastrski načrt je uradna zemljiška evidenca, ki vsebuje podrobne informacije o zemljiščih, parcelah in lastništvu na določenem geografskem območju. Kataster se uporablja za natančno določanje meja zemljišč, zabeležbo lastništva, določanje davčne osnove in drugih administrativnih namenov.
                            </p>
                            <p class="text-body-regular">
                                Pomembne značilnosti katastrskega načrta vključujejo:
                            </p>
                            <ul class="mb-4 text-body-regular list-disc pl-6">
                                <li>
                                    Parcelne meje: Prikazujejo natančne meje posameznih parcel zemljišča. Te meje so običajno določene s pomočjo koordinat, zemljepisne širine in dolžine.
                                </li>
                                <li>
                                    Številke parcel: Vsaka parcela na katastrskem načrtu ima svojo enolično identifikacijsko številko, ki se uporablja za prepoznavanje lastništva in druge informacije.
                                </li>
                                <li>
                                    Lastništvo: Kataster vsebuje informacije o lastnikih zemljišč, kar omogoča sledenje lastniškim pravicam.
                                </li>
                                <li>
                                    Topografske značilnosti: Prikazujejo naravne in umetne značilnosti zemljišča, kot so reke, ceste, stavbe itd.
                                </li>
                                <li>
                                    Administrativne meje: Katastrske karte lahko prikazujejo tudi administrativne meje, kot so občinske meje, ki so pomembne za upravljanje in organizacijo na lokalni ravni.
                                </li>
                            </ul>
                            <p class="mb-8 text-body-regular">
                                Katastrski načrti so ključni za vzpostavitev jasnega in zanesljivega sistema zemljiškega lastništva ter omogočajo učinkovito upravljanje zemljiških evidenc. Te informacije so pomembne za lastnike nepremičnin, kupce, oblikovalce prostora, javne organe in druge, ki delujejo v zvezi z nepremičninami.
                            </p>

                            <p class="mb-[10px] text-icon-text-medium">
                                Izjava občine
                            </p>
                            <p class="mb-8 text-body-regular">
                                Izjava občine pri nepremičnini je pisno potrdilo ali dokument, ki ga izda občina v zvezi z določeno nepremičnino. Ta izjava vsebuje informacije, ki so pomembne za lastništvo, namembnost, prostorsko urejanje ali druge vidike, povezane z nepremičnino. Natančne vsebine in pomen izjave občine se lahko razlikujejo glede na lokalne predpise in prakse.
                            </p>
                        </template>
                    </v-lightbox>
                </figure>
                <form
                    method="POST"
                    :action="routes.submitForm"
                    id="select-estate-documentation"
                >
                    <v-csrf-token></v-csrf-token>
                    <figure class="ml-auto mr-auto w-full max-w-lg">
                        <ul class="flex flex-col gap-4">
                            <li
                                class="col-span-4"
                                v-for="(
                                    document, onOfficeEnum
                                ) in stepData.documentation_types_options"
                                :key="'document-' + onOfficeEnum"
                            >
                                <v-checkbox
                                    class="text-small-text-medium text-black-78"
                                    :label="stepData.labels[onOfficeEnum].label"
                                    checkbox-position="right"
                                    :name="
                                        'documentation_types[' +
                                        onOfficeEnum +
                                        ']'
                                    "
                                    :value="onOfficeEnum"
                                    :checked="
                                        stepData.documentation_types != null &&
                                        stepData.documentation_types[
                                            onOfficeEnum
                                        ]
                                    "
                                ></v-checkbox>
                            </li>
                        </ul>
                    </figure>
                </form>
            </figure>
        </main>
        <v-add-listing-foot>
            <a
                @click="submitForm('select-estate-documentation')"
                class="button button--md h-[48px] w-[240px] px-6"
            >
                <label class="text-small-text-medium">Nadaljujte</label>
                <v-icon icon="arrow-right" size="4"></v-icon>
            </a>
        </v-add-listing-foot>
    </section>
</template>
<script>
import AddListingFootVue from "../AddListingFoot.vue";
import AddListingHeadVue from "../AddListingHead.vue";

export default {
    components: {
        "v-add-listing-foot": AddListingFootVue,
        "v-add-listing-head": AddListingHeadVue,
    },
    props: {
        old: {
            type: Object,
            required: false,
            default: {},
        },
        routes: {
            type: Object,
            required: true,
        },
        validationErrors: {
            type: Object,
            required: true,
            default: {},
        },
        stepData: {
            type: Object,
            required: true,
            default: {},
        },
    },
    data() {
        return {};
    },
    mounted() {},
    computed: {},
    methods: {
        submitForm(formId) {
            document.getElementById(formId).submit();
        },
    },
};
</script>
